import { render } from "./loadingComponent.vue?vue&type=template&id=28290bfc&scoped=true"
const script = {}

import "./loadingComponent.vue?vue&type=style&index=0&id=28290bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28290bfc"]])

export default __exports__